import { ApplicationFrameComponent } from './ApplicationFrame.component';

export const ApplicationFrame = ApplicationFrameComponent;
